import * as _ from 'lodash';
import * as moment from 'moment';
import { ItemIdModel } from '../models/filter-model/item-id-model';
import { AuditTrailDto } from '../models/view-model/audit-trail-dto';
import { RulebookFilterModel } from '../models/rulebook/rulebook-filters-model';
import { LinkedUpdateFilterModel } from '../models/rulebook/linked-update-filter-model';
import { ImpactAssessmentFilter } from '../models/impact-assessment/impact-assessment-filter';
import { SelfAssessmentFilter } from 'src/app/core/models/self-assessment/self-assessment-filter';
import { RegulationFilterModel, LibraryFilterModel, RegulationActionFilterModel } from '../models/regulation';
import { ImpactAssessmentFilterT4 } from '../models/impact-assessment/impact-assessmentT4-filter';
import { SelfAssessmentT2Filter } from '../models/self-assessmentT2/seld-assessmentT2-filter';
import { SelfAssessmentT3Filter } from '../models/self-assessmentT3/selft-assessmentT3-filter';
import { ImpactAssessmentFilterT6 } from '../models/impact-assessment/ImpactAssessmentFilterT6';

export class MasterHelper {
  static getDate(daysDiff: number): any {
    return moment(new Date()).subtract(daysDiff, 'days') //.format('YYYY-MM-DD');
  }

  static getDateStr(daysDiff: number): any {
    return moment(new Date()).subtract(daysDiff, 'days').format('YYYY-MM-DDTHH:mm:ssZ');
  }

  static getCurrrentDateTime(format: string): any {
    return moment(new Date()).format(format);
  }

  static getExpirationDateTime(): any {
    return moment(new Date()).add(1, 'hours');
  }

  static formatDate(date: string, format: string): any {
    return moment(new Date(date)).format(format);
  }

  static parseDate(date: Date): any {
    return moment(new Date(date)).toDate(); // .format(format);
  }

  static parseDateStr(date: string): any {
    return moment(new Date(date)).toDate(); // .format(format);
  }

  static parseRegulationFilters(filter: RegulationFilterModel | null): any {
    if (filter) {
      // filter.FromDate = filter.FromDate ? this.formatDate(filter.FromDate, 'YYYY-MM-DD') : null; // Bug number 442
      // filter.ToDate = filter.ToDate ? this.formatDate(filter.ToDate, 'YYYY-MM-DD') : null; // Bug number 442
      // tslint:disable-next-line:max-line-length
      filter.MappingID = filter.MappingID && filter.MappingID.length > 0 ? filter.MappingID : null;
      filter.Regulator = filter.Regulator && filter.Regulator.length > 0 ? filter.Regulator : null;
      filter.SearchQuery =
        filter.SearchQuery && filter.SearchQuery.length > 0
          ? filter.SearchQuery
          : [];
      filter.Status = filter.Status && filter.Status.length > 0 ? filter.Status : null;
    }
    return filter;
  }

  static parseRulebookFilters(filter: RulebookFilterModel | null): any {
    if (filter) {
      //filter.fromDate = filter.fromDate ? this.formatDate(filter.fromDate, 'YYYY-MM-DD') : null; // Removed to correct time zone errors // Bug number 442
      //filter.toDate = filter.toDate ? this.formatDate(filter.toDate, 'YYYY-MM-DD') : null; // Removed to correct time zone errors // Bug number 442
      filter.geography = filter.geography && filter.geography.length > 0 ? filter.geography : [];
      filter.country = filter.country && filter.country.length > 0 ? filter.country : [];
      filter.rulebook = filter.rulebook && filter.rulebook.length > 0 ? filter.rulebook : [];
      filter.searchQuery =
        filter.searchQuery && filter.searchQuery.length > 0
          ? filter.searchQuery
          : [];
    }
    return filter;
  }

  static parseLinkedUpdateFilters(filter: LinkedUpdateFilterModel | null): any {
    if (filter) {
      // filter.fromDate = filter.fromDate ? this.formatDate(filter.fromDate, 'YYYY-MM-DD') : null; // Removed to correct time zone errors // Bug number 442
      // filter.toDate = filter.toDate ? this.formatDate(filter.toDate, 'YYYY-MM-DD') : null; // Removed to correct time zone errors // Bug number 442
      filter.regulator = filter.regulator && filter.regulator.length > 0 ? filter.regulator : null;
      filter.searchQuery =
        filter.searchQuery && filter.searchQuery.length > 0
          ? filter.searchQuery
          : [];
    }
    return filter;
  }

  static parseLibraryFilters(filter: LibraryFilterModel | null): any {
    if (filter) {
      // filter.FromDate = filter.FromDate ? this.formatDate(filter.FromDate, 'YYYY-MM-DD') : null; // Removed to correct time zone errors // Bug number 442
      // filter.ToDate = filter.ToDate ? this.formatDate(filter.ToDate, 'YYYY-MM-DD') : null; // Removed to correct time zone errors // Bug number 442
      // tslint:disable-next-line:max-line-length
      filter.MappingID = filter.MappingID && filter.MappingID.length > 0 ? filter.MappingID : null;
      filter.Regulator = filter.Regulator && filter.Regulator.length > 0 ? filter.Regulator : null;
    }
    return filter;
  }

  static parseRegulationActionFilters(filter: RegulationActionFilterModel | null): any {
    if (filter) {
      // filter.FromDate = filter.FromDate ? this.formatDate(filter.FromDate, 'YYYY-MM-DD') : null; // Removed to correct time zone errors // Bug number 442
      // filter.ToDate = filter.ToDate ? this.formatDate(filter.ToDate, 'YYYY-MM-DD') : null; // Removed to correct time zone errors // Bug number 442
      filter.MappingID = filter.MappingID && filter.MappingID.length > 0 ? filter.MappingID : null;
      filter.Regulator = filter.Regulator && filter.Regulator.length > 0 ? filter.Regulator : null;
      filter.Types = filter.Types && filter.Types.length > 0 ? filter.Types : null;
      filter.Topics = filter.Topics && filter.Topics.length > 0 ? filter.Topics : null;
      filter.ImpactAreas = filter.ImpactAreas && filter.ImpactAreas.length > 0 ? filter.ImpactAreas : null;
      filter.Status = filter.Status && filter.Status.length > 0 ? filter.Status : null;
      filter.Impacts = filter.Impacts && filter.Impacts.length > 0 ? filter.Impacts : null;
      filter.Assessments = filter.Assessments && filter.Assessments.length > 0 ? filter.Assessments : null;

      filter.SearchQuery = filter.SearchQuery && filter.SearchQuery !== 'null' ? filter.SearchQuery : null;
      filter.Status = filter.Status && filter.Status.length > 0 ? filter.Status : null;
      filter.ActionDateFrom = filter.ActionDateFrom ? this.formatDate(filter.ActionDateFrom, 'YYYY-MM-DD') : null;
      filter.ActionDateUntil = filter.ActionDateUntil ? this.formatDate(filter.ActionDateUntil, 'YYYY-MM-DD') : null;
      filter.EffectiveDateFrom = filter.EffectiveDateFrom ? this.formatDate(filter.EffectiveDateFrom, 'YYYY-MM-DD') : null;
      filter.EffectiveDateUntil = filter.EffectiveDateUntil ? this.formatDate(filter.EffectiveDateUntil, 'YYYY-MM-DD') : null;
    }
    return filter;
  }

  static bsdatePickerToCorrectDate(dateString: string): any {
    const correctDate = new Date(dateString);
    return new Date(Date.UTC(correctDate.getFullYear(), correctDate.getMonth(), correctDate.getDate(),
      correctDate.getHours(), correctDate.getMinutes(), correctDate.getSeconds()));
  }

  static parseAuditTrailFilters(filter: AuditTrailDto | null): any {
    if (filter) {
      filter.users = filter.users && filter.users.length > 0 ? filter.users : [];
      filter.screens = filter.screens && filter.screens.length > 0 ? filter.screens : [];
      filter.functions = filter.functions && filter.functions.length > 0 ? filter.functions : [];
      filter.actions = filter.actions && filter.actions.length > 0 ? filter.actions : [];
      filter.searchQuery =
        filter.searchQuery && filter.searchQuery.length > 0
          ? filter.searchQuery
          : [];
    }
    return filter;
  }

  static parseSelfAssessmentFilters(filter: SelfAssessmentFilter | null): any {
    if (filter) {
      // filter.fromDate = filter.fromDate ? this.formatDate(filter.fromDate, 'YYYY-MM-DD') : null; // Removed to correct time zone errors // Bug number 442
      // filter.toDate = filter.toDate ? this.formatDate(filter.toDate, 'YYYY-MM-DD') : null; // Removed to correct time zone errors // Bug number 442
      // filter.legalEntity = filter.legalEntity && filter.legalEntity.length > 0 ? filter.legalEntity : [];
      // filter.assessmentTeam = filter.assessmentTeam && filter.assessmentTeam.length > 0 ? filter.assessmentTeam : [];
      // filter.reviewTeam = filter.reviewTeam && filter.reviewTeam.length > 0 ? filter.reviewTeam : [];
      // filter.actionTeam = filter.actionTeam && filter.actionTeam.length > 0 ? filter.actionTeam : [];
      // filter.assessmentStatus = filter.assessmentStatus && filter.assessmentStatus.length > 0 ? filter.assessmentStatus : [];
      // filter.reviewStatus = filter.reviewStatus && filter.reviewStatus.length > 0 ? filter.reviewStatus : [];
      // filter.actionStatus = filter.actionStatus && filter.actionStatus.length > 0 ? filter.actionStatus : [];
      // filter.ruleConclusion = filter.ruleConclusion && filter.ruleConclusion.length > 0 ? filter.ruleConclusion : [];
      // filter.overallRuleStatus = filter.overallRuleStatus && filter.overallRuleStatus.length > 0 ? filter.overallRuleStatus : [];
      // filter.gapReviewStatus = filter.gapReviewStatus && filter.gapReviewStatus.length > 0 ? filter.gapReviewStatus : [];
      // filter.searchQuery =
      //   filter.searchQuery && filter.searchQuery.length > 0
      //     ? filter.searchQuery
      //     : [];
    }
    return filter;
  }

  static parseSelfAssessmentT2Filters(filter: SelfAssessmentT2Filter | null): any{
    if(filter){
    }
    return filter;
  }
  static parseSelfAssessmentT3Filters(filter: SelfAssessmentT3Filter | null): any{
    if(filter){
    }
    return filter;
  }
  static parseImpactAssessmentFilters(filter: ImpactAssessmentFilter|null): any {
    if (filter) {
      // filter.fromDate = filter.fromDate ? this.formatDate(filter.fromDate, 'YYYY-MM-DD') : null; // Removed to correct time zone errors // Bug number 442
      // filter.toDate = filter.toDate ? this.formatDate(filter.toDate, 'YYYY-MM-DD') : null; // Removed to correct time zone errors // Bug number 442
      filter.legalEntity = filter.legalEntity && filter.legalEntity.length > 0 ? filter.legalEntity : [];
      filter.assessmentTeam = filter.assessmentTeam && filter.assessmentTeam.length > 0 ? filter.assessmentTeam : [];
      filter.reviewTeam = filter.reviewTeam && filter.reviewTeam.length > 0 ? filter.reviewTeam : [];
      filter.implementationTeam = filter.implementationTeam && filter.implementationTeam.length > 0 ?
        filter.implementationTeam : [];
      filter.assessmentStatus = filter.assessmentStatus && filter.assessmentStatus.length > 0 ? filter.assessmentStatus : [];
      filter.reviewStatus = filter.reviewStatus && filter.reviewStatus.length > 0 ? filter.reviewStatus : [];
      filter.implementationStatus = filter.implementationStatus && filter.implementationStatus.length > 0 ?
        filter.implementationStatus : [];
      filter.searchQuery =
        filter.searchQuery && filter.searchQuery.length > 0
          ? filter.searchQuery
          : [];
    }
    if(filter?.RegulationId && filter?.RegulationId.length > 0){
      filter.RegulationId=filter?.RegulationId && filter.RegulationId.length > 0 ?
      filter.RegulationId : [];
    }
    
    return filter;
  }

  static parseImpactAssessmentT4Filters(filter: ImpactAssessmentFilterT4|null): any {
    if (filter) {
      // filter.fromDate = filter.fromDate ? this.formatDate(filter.fromDate, 'YYYY-MM-DD') : null; // Removed to correct time zone errors // Bug number 442
      // filter.toDate = filter.toDate ? this.formatDate(filter.toDate, 'YYYY-MM-DD') : null; // Removed to correct time zone errors // Bug number 442
      filter.assessmentStatus = filter.assessmentStatus && filter.assessmentStatus.length > 0 ? filter.assessmentStatus : [];
      filter.searchQuery =
        filter.searchQuery && filter.searchQuery.length > 0
          ? filter.searchQuery
          : [];
    }
    if(filter?.RegulationId && filter?.RegulationId.length > 0){
      filter.RegulationId=filter?.RegulationId && filter.RegulationId.length > 0 ?
      filter.RegulationId : [];
    }
    
    return filter;
  }

  // static parseImpactAssessmentT5Filters(filter: ImpactAssessmentFilterT4|null): any {
  //   if (filter) {
  //     filter.assessmentStatus = filter.assessmentStatus && filter.assessmentStatus.length > 0 ? filter.assessmentStatus : [];
  //     filter.searchQuery =
  //       filter.searchQuery && filter.searchQuery.length > 0
  //         ? filter.searchQuery
  //         : [];
  //   }
  //   if(filter?.RegulationId && filter?.RegulationId.length > 0){
  //     filter.RegulationId=filter?.RegulationId && filter.RegulationId.length > 0 ?
  //     filter.RegulationId : [];
  //   }
    
  //   return filter;
  // }

  static parseImpactAssessmentT6Filters(filter: ImpactAssessmentFilterT6|null): any {
    if (filter) {
      filter.assessmentTeam = filter.assessmentTeam && filter.assessmentTeam.length > 0 ? filter.assessmentTeam : [];
      filter.assessmentStatus = filter.assessmentStatus && filter.assessmentStatus.length > 0 ? filter.assessmentStatus : [];
      filter.searchQuery = filter.searchQuery && filter.searchQuery.length > 0 ? filter.searchQuery: [];
    }
    if(filter?.RegulationId && filter?.RegulationId.length > 0){
      filter.RegulationId=filter?.RegulationId && filter.RegulationId.length > 0 ?
      filter.RegulationId : [];
    }
    return filter;
  }

  static saveOnBrowser(key: string, value: string): void {
    localStorage.setItem(key, value);
  }

  static fetchFromBrowser(key: string): string|null {
    return localStorage.getItem(key);
  }

  static removeFromBrowser(key: string): void {
    localStorage.removeItem(key);
  }

  static getStringFromObjectArray(object: Array<ItemIdModel>): string {
    const stringArr = new Array<string>();
    object.forEach(element => {
      stringArr.push(element.name);
    });
    return stringArr.join(',');
  }

  static getStringArrayFromObjectArray(object: Array<ItemIdModel>): string[] {
    const stringArr = new Array<string>();
    object.forEach(element => {
      stringArr.push(element.name);
    });
    return stringArr;
  }

  static getDistinctValues(itemArray: string[]): string[] {
    return itemArray.filter((v, i, a) => a.indexOf(v) === i);
  }

  static sortArray(itemArray: string[], key: string): string[] {
    if (key === 'asc') {
      return itemArray.sort((a, b) => a.toLowerCase().trim() < b.toLowerCase().trim()
        ? -1 : a.toLowerCase().trim() > b.toLowerCase().trim() ? 1 : 0);
    } else {
      return itemArray.sort((a, b) => a.toLowerCase().trim() < b.toLowerCase().trim()
        ? 1 : a.toLowerCase().trim() > b.toLowerCase().trim() ? -1 : 0);
    }
  }

  static removeNullFromArray(itemArray: string[]): string[] {
    return itemArray.filter(item => item);
  }

  static replaceAll(str:any, find:any, replace:any): string {
    const escapedFind = find.replace(/([.*+?^=!:${}()|\[\]\/\\])/g, '\\$1');
    return str.replace(new RegExp(escapedFind, 'g'), replace);
  }
  static sortArrayByDate(itemArray: string[], key: string): string[] {
    if (key === 'asc') {
      return itemArray.sort((a, b) => new Date(a.substring(a.length - 18).slice(0, -1)) < new Date(b.substring(b.length - 18).slice(0, -1))
      ? -1 : new Date(a.substring(a.length - 18).slice(0, -1)) > new Date(b.substring(b.length - 18).slice(0, -1)) ? 1 : 0);

    } else {
      return itemArray.sort((a, b) => new Date(a.substring(a.length - 18).slice(0, -1)) < new Date(b.substring(b.length - 18).slice(0, -1))
      ? 1 : new Date(a.substring(a.length - 18).slice(0, -1)) > new Date(b.substring(b.length - 18).slice(0, -1)) ? -1 : 0);
    }

  }
}
